import React from 'react';
import Modal from 'react-bootstrap/Modal';

class UserAccessTableButtons extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      actionType: null // 'delete' or 'remove'
    };
  }

  handleShowModal = (actionType) => {
    this.setState({ showModal: true, actionType });
  }

  handleHideModal = () => {
    this.setState({ showModal: false, actionType: null });
  }

  handleConfirmAction = () => {
    if (this.state.actionType === 'delete') {
      this.props.deleteUser(this.props.user);
    } else if (this.state.actionType === 'remove') {
      this.props.removeUser(this.props.user, this.props.org_id);
    }
    this.handleHideModal();
  }

  render() {
    const { showModal, actionType } = this.state;

    return (
      <React.Fragment>
        <button className="lite-btn lite-btn-sm btn-default mr-3" onClick={() => window.location.href = "/datapulse/users/" + this.props.user.id + "/edit"}>
          Edit User
        </button>
        {this.props.current_user_is_god &&
          <button className="lite-btn lite-btn-sm btn-danger mr-3" onClick={() => this.handleShowModal('delete')}>
            Delete User
          </button>
        }
        {this.props.user.role !== 'unaffiliated' &&
          <button className="lite-btn lite-btn-sm btn-danger mr-3" onClick={() => this.handleShowModal('remove')}>
          Remove User
        </button>
        }

        <Modal show={showModal} onHide={this.handleHideModal}>
          <Modal.Header closeButton>
            <Modal.Title>
              <h4>Confirm Action</h4>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <p className="mb-4">
                {actionType === 'delete' ? 'Are you sure you want to permanently delete this user from the database?' :
                'Are you sure you want to remove this user from the selected organization?'}
              </p>
              <button className="lite-btn btn-default mr-3" onClick={this.handleHideModal}>
                Cancel
              </button>
              <button className="lite-btn btn-danger" onClick={this.handleConfirmAction}>
                Confirm
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }
}

export default UserAccessTableButtons;
